import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useProjectSiteNavigation, useProjectSiteParams } from '@/shared/lib';
import { useGetConsignmentByIdQuery } from '@/entities/consignments';

export function useConsignmentEdit(consignmentId?: string) {
  const { t } = useTranslation();
  const { navigateWithContext } = useProjectSiteNavigation();
  const { projectId, siteId } = useProjectSiteParams();

  const {
    data: consignmentData,
    isFetching,
    isLoading
  } = useGetConsignmentByIdQuery(
    {
      id: consignmentId!,
      projectId,
      siteId
    },
    {
      skip: !consignmentId || !projectId || !siteId
    }
  );

  const handleSave = useCallback(
    async (formData: unknown) => {
      if (!consignmentId) {
        toast.error('No consignment ID provided');
        return;
      }

      if (consignmentData?.readonly) {
        toast.error(t('newcmr.readonly.message'));
        return;
      }

      try {
        // TODO: Implement API call to save consignment
        console.log('Saving consignment:', consignmentId, formData);
        toast.success(t('newcmr.save.success'));
      } catch (error) {
        toast.error(t('newcmr.save.error'));
        console.error('Failed to save consignment:', error);
      }
    },
    [consignmentId, consignmentData?.readonly, t]
  );

  const handleCancel = useCallback(() => {
    navigateWithContext('requests');
  }, [navigateWithContext]);

  return {
    handleSave,
    handleCancel,
    isLoading: isLoading || isFetching,
    consignmentData,
    isReadOnly: !!consignmentData?.readonly
  };
}
